import { Storage } from '@ionic/storage';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import moment from 'moment';

import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class PageBuilderValidationHelper {

    constructor(
        public storage: Storage,
        public http: Http,
        public _translate?: TranslateService,
    ) { }

    handleCustomValidation(widget) {
        if (widget.hasOwnProperty('bottomTitleTextareaValidation') && widget.bottomTitleTextareaValidation && widget.bottomTitleTextareaValidation.hasOwnProperty('validation')) {
            if (widget.bottomTitle) widget.name = widget.bottomTitle;
            widget.validation = widget.bottomTitleTextareaValidation.validation;
        }
    }

    public pageValidation(widgets, values): Promise<any> {
        console.log('widgets', widgets);
        return new Promise(async (resolve) => {

            let responseTmp = { status: true, message: null };

            let i = 0;
            for (i = 0; i < widgets.length; i++) {
                const widget = widgets[i];
                if (widget.widget == 'gd-looping') {
                    const loopingValue = values[widget.value];
                    console.log(loopingValue);
                    if(typeof loopingValue === 'undefined') {
                        return resolve(responseTmp)
                    }
                    for (let i = 0; i < loopingValue.length; i++) {
                        responseTmp = await this.pageValidation(widget.widgets, values[widget.value][i]);
                        if (responseTmp && responseTmp.status == false) {
                            resolve(responseTmp);
                            return;
                        }
                    }
                } else if (widget.widgets) {
                    responseTmp = await this.pageValidation(widget.widgets, values);
                    resolve(responseTmp);
                    return;
                }

                if (widget.validation) {
                    console.log(widget);
                    let value = values[widget.name];
                    console.log(value);
                    console.log(values);
                    responseTmp = this.validations(responseTmp, widget, value, values);
                }
                if (responseTmp && responseTmp.status == false) {
                    resolve(responseTmp);
                    return;
                }
            }

            if (widgets) {
                console.log("MASUK 1");
                console.log(values);
                if (values.constructor.name != 'Array') {
                    console.log("MASUK 2");
                    console.log(widgets);
                    responseTmp = this.validations(responseTmp, widgets, values, values, true);
                    if (responseTmp.status == false) {
                        resolve(responseTmp);
                        console.log("RETURN");
                        i = widgets.length;
                        return;
                    }
                }
            }

            resolve(responseTmp);

        })
    }

    validations(responseTmp, widget, value, values, trueCondition = false) {
        for (var validationKey in widget.validation) {
            let condition = widget.validation[validationKey];
            const isRequiredCanZero = validationKey == 'isRequired' && widget.validation.isRequiredCanZero ? widget.validation.isRequiredCanZero : false;
            console.log(widget.validation);
            console.log(responseTmp, widget, value, values, trueCondition)
            switch (validationKey) {
                case "isRequired": responseTmp = this.isRequired(widget.name, widget.label, trueCondition ? trueCondition : condition, value, isRequiredCanZero); break;
                case "minLength": responseTmp = this.minLength(widget.name, condition, value); break;
                case "maxLength": responseTmp = this.maxLength(widget.name, condition, value); break;
                case "minValue": responseTmp = this.minValue(widget.name, widget.label, condition, value); break;
                case "maxValue": responseTmp = this.maxValue(widget.name, widget.label, condition, value); break;
                case "isInRange": responseTmp = this.isInRange(widget.name, condition, value); break;
                case "isEmail": responseTmp = this.isEmail(widget.name, condition, value); break;
                case "isDateFormat": responseTmp = this.isDateFormat(widget.name, condition, value); break;
                case "isDateInRange": responseTmp = this.isDateInRange(widget.name, condition, value, values); break;
                case "isOnlyNumber": responseTmp = this.isOnlyNumber(widget.name, condition, value); break;
                case "isOnlyAlphabet": responseTmp = this.isOnlyAlphabet(widget.name, condition, value); break;
                case "isGreaterThan": responseTmp = this.isGreaterThan(widget.name, condition, value); break;
                case "isGreaterThanEqual": responseTmp = this.isGreaterThanEqual(widget.name, condition, value); break;
                case "isLessThan": responseTmp = this.isLessThan(widget.name, condition, value); break;
                case "isLessThanEqual": responseTmp = this.isLessThanEqual(widget.name, condition, value); break;
                case "isSpecialCharacter": responseTmp = this.isSpecialCharacter(widget.name, widget.label, condition, value); break;
            }

            console.log(responseTmp);
            if (responseTmp.status == false) {
                return responseTmp;
            } else {

            }
        }
        return responseTmp;
    }

    private isRequired(key, label = null, condition, value, isCanZero?: boolean) {
        console.log('TCL REquiered', condition, value);
        if ((condition == true || condition == "true" || condition == 1 || condition == "1") && (value == null || value == undefined || value == "" || value == 0 || value == {} || value == [])) {
            console.log("MASUK FALSE");
            if (isCanZero && value == 0) {
                let res = { status: true, message: null };
                return (res);
            }

            let msg = (label) ? label : key;
            let res = {
                status: false,
                message: this._translate.instant(msg) + " " + this._translate.instant('str_required') + "!"
            };
            return (res);
        } else {
            console.log("MASUK TRUE");
            let res = { status: true, message: null };
            return (res);
        }
    }

    private minLength(key, condition, value) {

        let len = 0;

        if (value instanceof Array) {
            len = value.length;
        } else {
            value += "";
            len = value.length;
        }

        if (len < parseInt(condition)) {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_minimum_length_is') + " : " + condition
            };
            return (res);
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private maxLength(key, condition, value) {
        let len = 0;

        if (value instanceof Array) {
            len = value.length;
        } else {
            value += "";
            len = len = value.length;
        }

        if (len > parseInt(condition)) {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_maximum_length_is') + " : " + condition
            };
            return (res);
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private minValue(key, label = null, condition, value) {
        value = Number(value);
        if (value.constructor.name == "Number") {
            if (value < parseInt(condition)) {
                let msg = (label) ? label : key;
                let res = {
                    status: false,
                    message: this._translate.instant(msg) + " " + this._translate.instant('validation_minimum_value_is') + condition
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_number')
            };
            return (res);
        }
    }

    private maxValue(key, label = null, condition, value) {
        value = Number(value);
        if (value.constructor.name == "Number") {
            if (value > parseInt(condition)) {
                let msg = (label) ? label : key;
                let res = {
                    status: false,
                    message: this._translate.instant(msg) + " " + this._translate.instant('validation_maximum_value_is') + condition
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_number')
            };
            return (res);
        }
    }

    private isInRange(key, condition, value) {
        if (value.constructor.name == "Number") {
            if (value <= parseInt(condition.min) && value >= parseInt(condition.max)) {
                let res = {
                    status: false,
                    message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_in_range')
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_number')
            };
            return (res);
        }
    }

    private isEmail(key, condition, value) {
        if (condition == true || condition == "true" || condition == 1 || condition == "1") {
            const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
            let check: boolean = expression.test(String(value).toLowerCase());
            if (!check) {
                let res = {
                    status: false,
                    message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_email')
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private isDateFormat(key, condition, value) {
        let isValid = moment(value, condition.toUpperCase(), true).isValid();
        if (!isValid) {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_date_format') + " : " + condition
            };
            return (res);
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private isDateInRange(key, condition, value, valueAlls?) {
        // console.log('TCL: DATE VALIDATION');
        console.log(condition);
        console.log(key);
        console.log(value);
        console.log("valueAlls", valueAlls);
        try {
            let startDate;
            let endDate;
            let date;
            let runningValidation: boolean = true;
            console.log('condition.value', condition.value.greater);

            if (condition.runValidationByParam && condition.runValidationByParamKey && condition.runValidationByParamValue) {
                runningValidation = valueAlls[condition.runValidationByParamKey] === condition.runValidationByParamValue ? true : false;
            }
            console.log('runningValidation', runningValidation);

            if (runningValidation) {
                if (condition.inValue && condition.value && condition.value.startDate === 'startDate' || condition.inValue && condition.value && condition.value.startDate === 'startdate') {
                    startDate = new Date(valueAlls[condition.value.startDate]);
                    endDate = new Date(valueAlls[condition.value.endDate]);
                    if (startDate < endDate) {
                        let res = { status: true, message: null };
                        return (res);
                    } else {
                        let res = {
                            status: false,
                            message: this._translate.instant("validation_end_date_must_be_greater_than_start_date")
                        };
                        return (res);
                    }
                } else if (condition.value.greater) {

                    const startDate: Date = moment(valueAlls.startDate).subtract(moment().utcOffset(), 'minutes').toDate();
                    const endDate: Date = moment(valueAlls.endDate).subtract(moment().utcOffset(), 'minutes').toDate();
                    const dateNowByPick: Date = moment(valueAlls.date).subtract(moment().utcOffset(), 'minutes').toDate();
                    const dateNow: Date = moment().subtract(moment().utcOffset(), 'minutes').toDate();

                    console.log('startDate', startDate);
                    console.log('endDate', endDate);
                    console.log('datenow', dateNow);
                    console.log('dateNowByPick', dateNowByPick);

                    console.log('dateNowByPick format', moment(dateNowByPick).format('YYYY-MM-DD'));
                    console.log('dateNow format', moment(dateNow).format('YYYY-MM-DD'));

                    // picker == today
                    if (moment(dateNowByPick).format('YYYY-MM-DD') === moment(dateNow).format('YYYY-MM-DD')) {
                        if (moment(startDate).isBefore(dateNow)) {
                            let res = {
                                status: false,
                                message: this._translate.instant('validation_start_date_must_be_greater_than_date_now')
                            };
                            return (res);
                        } else if (moment(startDate).isAfter(endDate)) {
                            let res = {
                                status: false,
                                message: this._translate.instant('validation_end_date_must_be_greater_than_start_date')
                            };
                            return (res);
                        } else {
                            let res = { status: true, message: null };
                            return (res);
                        }
                    } else {
                        // picker != today
                        console.log('second condition MP')
                        if (endDate < startDate) {
                            let res = {
                                status: false,
                                message: this._translate.instant('validation_end_date_must_be_greater_than_start_date')
                            };
                            return (res);
                        } else {
                            let res = { status: true, message: null };
                            return (res);
                        }
                    }
                } else {
                    startDate = new Date(condition.startDate).toISOString();
                    endDate = new Date(condition.endDate).toISOString();
                    date = new Date(value).toISOString();

                    if (startDate <= date && date <= endDate) {
                        let res = { status: true, message: null };
                        return (res);
                    } else {
                        let res = {
                            status: false,
                            message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_range')
                        };
                        return (res);
                    }
                }
            } else {
                let res = { status: true, message: null };
                return (res);
            }

        } catch (err) {
            let res = {
                status: false,
                message: this._translate.instant('validation_invalid_format_date')
            };
            return (res);
        }
    }

    private isOnlyNumber(key, condition, value) {
        if (condition == true || condition == "true" || condition == 1 || condition == "1") {
            if (!isNaN(value)) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_number')
                };
                return (res);
            }
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private isOnlyAlphabet(key, condition, value) {
        if (condition == true || condition == "true" || condition == 1 || condition == "1") {
            const expression = /^[A-Za-z]+$/;
            let check: boolean = expression.test(String(value).toLowerCase());
            if (!check) {
                let res = {
                    status: false,
                    message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_alphabet')
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private isGreaterThan(key, condition, value) {
        let isOnlyNumber = this.isOnlyNumber(key, true, value);
        if (isOnlyNumber.status) {
            if (value > condition) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_greater_than') + " " + condition
                };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_number')
            };
            return (res);
        }
    }

    private isGreaterThanEqual(key, condition, value) {
        let isOnlyNumber = this.isOnlyNumber(key, true, value);
        if (isOnlyNumber.status) {
            if (value >= condition) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_greater_than_equal') + " " + condition
                };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_number')
            };
            return (res);
        }
    }

    private isLessThan(key, condition, value) {
        let isOnlyNumber = this.isOnlyNumber(key, true, value);
        if (isOnlyNumber.status) {
            if (value < condition) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_less_than') + " " + condition
                };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_number')
            };
            return (res);
        }
    }

    private isLessThanEqual(key, condition, value) {
        let isOnlyNumber = this.isOnlyNumber(key, true, value);
        if (isOnlyNumber.status) {
            if (value <= condition) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_less_than_equal') + " " + condition
                };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: this._translate.instant(key) + " " + this._translate.instant('validation_is_not_number')
            };
            return (res);
        }
    }

    private isSpecialCharacter(key, label = null, condition, value) {
        let msg = (label) ? label : key;
        if (condition.length > 0) {
            let res = {
                status: true,
                message: null
            };
            let parseVal = String(value);
            let specialCharacter = '"';
            condition.forEach((item, index) => {
                specialCharacter += item;
                if (index != condition.length - 1) {
                    specialCharacter += ", ";
                }
            });
            specialCharacter += '"';
            for (let item of condition) {
                if (parseVal.indexOf(item) > -1) {
                    res['status'] = false;
                    res['message'] = this._translate.instant(msg) + " " + this._translate.instant('validation_cannot_user_character') + " " + specialCharacter;
                    break;
                }
            }
            return (res);
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

}


// WEBPACK FOOTER //
// ./src/pagebuilder/providers/validation/v2/validation.builder.ts